module.exports = "/images/vessel-10.jpg";